import { render, staticRenderFns } from "./ProjectAddictionalCosts.vue?vue&type=template&id=0452167b"
import script from "./ProjectAddictionalCosts.vue?vue&type=script&lang=js"
export * from "./ProjectAddictionalCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports